/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { buildNamespace } from '@airasia-rn/ui';
import enGb from './en-gb.json';
import idId from './id-id.json';
import thTh from './th-th.json';
import jaJp from './ja-jp.json';
import koKr from './ko-kr.json';
import msMy from './ms-my.json';
import viVn from './vi-vn.json';
import zhCn from './zh-cn.json';
import zhHk from './zh-hk.json';
import zhTw from './zh-tw.json';
import trTr from './tr-tr.json';
import ruRu from './ru-ru.json';
import kmKh from './km-kh.json';
import uzUz from './uz-uz.json';

export const locales = buildNamespace(
  'home',
  enGb,
  idId,
  thTh,
  jaJp,
  koKr,
  msMy,
  viVn,
  zhCn,
  zhHk,
  zhTw,
  trTr,
  ruRu,
  kmKh,
  uzUz,
);
